module.exports = __webpack_public_path__ + "static/media/bg-header.75fc46b2.png";